import Icon, { EditOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Popover, Row, Typography } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { NotePickModal } from '../../../..';
import { BookmarkOutlined } from '../../../../../assets/icons/icons';
import { AdminRoutes } from '../../../../../features/admin';
import { VerdictService } from '../../../../api';
import { DisplayDateFormat } from '../../../../constants';
import { UserRoleEnum } from '../../../../enums';
import {
  DecisionInterface,
  LicenceInterface,
  NoteResponseInterfaceAll,
  ResponseInterface,
  TagScreenResponseInterface,
  VerdictInterface,
} from '../../../../interfaces';
import { StoreStateInterface } from '../../../../redux';
import { i18n } from '../../../../services';
import DecisionsDetailsDrawer from '../../../decisionsDetailsDrawer/decisionsDetailsDrawer.component';

const { Paragraph, Text } = Typography;

interface Props {
  response?: ResponseInterface;
  tags?: Array<TagScreenResponseInterface>;
  licenceData?: LicenceInterface;
  notes?: NoteResponseInterfaceAll;
  validLicences?: LicenceInterface[];
}

export default function VUSAppealCardComponent({ response, tags, licenceData, notes, validLicences }: Props) {
  const userAuth = useSelector((state: StoreStateInterface) => state.auth);

  const [verdict, setVerdict] = useState<VerdictInterface['attributes']>();
  const [decision, setDecision] = useState<DecisionInterface['attributes']>();
  const [visible, setVisible] = useState(false);

  const availableNotes = licenceData?.attributes?.notesNum as number;

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    if (!((notes?.data.length as number) == availableNotes)) {
      setVisible(true);
    }
    setVisible(false)
  };

  const handleCancel = () => {
    setVisible(false);
  };

  useEffect(() => {
    const id = response?.relationships?.verdict?.data?.id
      ? response?.relationships?.verdict?.data?.id
      : response?.attributes?.verdict?.id;
    if (id) {
      setVerdict(response?.attributes?.verdict);
      setDecision(response?.attributes?.verdict?.decision);
      /**
      VerdictService.getSingle(id).subscribe(
        (response: any) => {
          setVerdict(response.data);
          setDecision(response.included[0]);
        },
        (error: Error) => {
          console.log(error);
        }
      );
      */
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  return (
    <div className="responseCard">
      {response ? (
        <>
          <Row className="row">
            <Col flex={4}>
              <Text className="dateTime" type="secondary">
                {verdict?.verdictNum} <Divider type="vertical" />{' '}
                {moment(verdict?.verdictDate).format(DisplayDateFormat)}
              </Text>
            </Col>
            <Col flex={0}>
              <Button
                type="link"
                className="cardBtn"
                onClick={showModal}
                icon={<Icon component={BookmarkOutlined} />}
              />

              {userAuth.user?.roles === UserRoleEnum.ADMIN && (
                <Link
                  to={AdminRoutes.VUS_DECLARATIONS.fullPath + `/${verdict?.id}`}
                  key={AdminRoutes.VUS_DECLARATIONS.fullPath + `/${verdict?.id}`}
                >
                  <Button type="link" className="cardBtn" icon={<EditOutlined />} />
                </Link>
              )}
            </Col>
          </Row>
          <Paragraph className='para' style={{ whiteSpace: 'pre-wrap' }}>{response?.attributes?.titleContent}</Paragraph>

          <DecisionsDetailsDrawer
            drawerTitle={i18n.translate('orders.title')}
            decision={decision}
            verdict={verdict}
            data={response}
            tags={tags}
            licenceData={licenceData}
            validLicences={validLicences}
          />

          <Divider />
          <NotePickModal
            isExternal={true}
            visible={visible}
            handleOk={handleOk}
            handleCancel={handleCancel}
            external={response}
            type="verdict_response"
            typeId={response?.id}
            breadcrumb={
              'Pravna zaštita/Praksa u RH/Presude VUS-a/Odgovori na tužbu/' + response?.attributes?.titleContent
            }
            number={response?.id}
            isEditable={true}
            active={true}
            licenceData={licenceData as LicenceInterface}
            validLicences={validLicences}
          />
        </>
      ) : null}
    </div>
  );
}
